import { render, staticRenderFns } from "./OAppFooter.vue?vue&type=template&id=11a8958e&scoped=true&"
import script from "./OAppFooter.vue?vue&type=script&lang=js&"
export * from "./OAppFooter.vue?vue&type=script&lang=js&"
import style0 from "./OAppFooter.vue?vue&type=style&index=0&id=11a8958e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a8958e",
  null
  
)

export default component.exports